const seo = {
  it: {
    home: {
      title: "ECLENIA | Corporate Health & Workplace Wellbeing",
      description:
        "ECLENIA: consulenza strategica in Corporate Health e Workplace Wellbeing. Strategie di salute e prevenzione basate sulle evidenze per la tua organizzazione.",
    },
    about: {
      title: "Founder | Alessia Zanella — ECLENIA",
      description:
        "Dal rigore delle life sciences alla consulenza strategica: Alessia Zanella, Founder di ECLENIA, Corporate Health & Workplace Wellbeing in Veneto.",
    },
    approach: {
      title: "Approccio | Health Strategy basata sulle evidenze",
      description:
        "Il metodo in quattro fasi per la salute organizzativa: diagnosi con questionari validati, modello a tre livelli, piano condiviso e monitoraggio.",
    },
    expertise: {
      title: "Competenze | Benessere Organizzativo e Salute Aziendale",
      description:
        "Corporate Health, Women's Health at Work, ergonomia aziendale, prevenzione e Health Culture: undici aree per organizzazioni in salute.",
    },
    insights: {
      title: "Insights | Organizational Health e Workplace Wellbeing",
      description:
        "Analisi e prospettive su Organizational Health, Employee Wellbeing e prevenzione sul lavoro, basate su dati e letteratura scientifica.",
    },
    "article-business-case": {
      title: "Business Case del Benessere Aziendale: i Dati | Eclenia",
      description:
        "Turnover, produttività, ROI: i dati Gallup, McKinsey e Health Affairs che dimostrano perché il benessere organizzativo è una leva di business.",
      keywords:
        "business case benessere aziendale, benessere organizzativo, ROI corporate wellbeing, produttività e benessere, employee wellbeing ROI",
    },
    "article-womens-health": {
      title: "Women's Health at Work: Dati e Strategie | Eclenia",
      description:
        "Menopausa, gender health gap, leadership femminile: i dati CIPD, McKinsey, Deloitte ed Eurostat su perché la salute femminile è una priorità organizzativa.",
      keywords:
        "women's health at work, salute femminile sul lavoro, menopausa in azienda, gender health gap, leadership femminile",
    },
    "article-rischio-psicosociale": {
      title: "Rischio Psicosociale in Azienda: Normativa e Dati | Eclenia",
      description:
        "Stress lavoro-correlato: la normativa D.Lgs. 81/2008, i costi secondo EU-OSHA e ILO, e perché la gestione del rischio psicosociale è una leva strategica.",
      keywords:
        "rischio psicosociale, stress lavoro-correlato, D.Lgs 81/2008 valutazione stress, compliance salute sul lavoro, prevenzione stress aziendale",
    },
    resources: {
      title: "Risorse | Strumenti per il benessere organizzativo",
      description:
        "Brief, self-assessment e checklist per HR e leader: strumenti pratici per costruire un benessere organizzativo misurabile e duraturo.",
    },
    contact: {
      title: "Contatti | ECLENIA — Corporate Health, Nove (VI)",
      description:
        "Prenota una Discovery Call con ECLENIA, consulenza in Corporate Health e Workplace Wellbeing. Sede a Nove (VI), Veneto.",
    },
  },
  en: {
    home: {
      title: "ECLENIA | Corporate Health & Workplace Wellbeing",
      description:
        "ECLENIA: strategic advisory in Corporate Health and Workplace Wellbeing. Evidence-based health and prevention strategies for your organization.",
    },
    about: {
      title: "Founder | Alessia Zanella — ECLENIA",
      description:
        "From life sciences rigor to strategic consulting: Alessia Zanella, Founder of ECLENIA, Corporate Health & Workplace Wellbeing in Italy.",
    },
    approach: {
      title: "Approach | Evidence-based Health Strategy",
      description:
        "A four-phase method for organizational health: diagnosis with validated questionnaires, a three-level model, shared plan and monitoring.",
    },
    expertise: {
      title: "Expertise | Organizational Health & Workplace Prevention",
      description:
        "Corporate Health, Women's Health at Work, occupational health strategy, ergonomics and Health Culture: eleven areas for healthy organizations.",
    },
    insights: {
      title: "Insights | Organizational Health & Employee Wellbeing",
      description:
        "Analysis and perspectives on Organizational Health, Employee Wellbeing and workplace prevention, grounded in data and scientific literature.",
    },
    "article-business-case": {
      title: "The Business Case for Corporate Wellbeing: the Data | Eclenia",
      description:
        "Turnover, productivity, ROI: the Gallup, McKinsey and Health Affairs data showing why organizational wellbeing is a business lever.",
      keywords:
        "corporate wellbeing business case, organizational wellbeing, corporate wellbeing ROI, productivity and wellbeing, employee wellbeing ROI",
    },
    "article-womens-health": {
      title: "Women's Health at Work: Data and Strategies | Eclenia",
      description:
        "Menopause, gender health gap, female leadership: CIPD, McKinsey, Deloitte and Eurostat data on why women's health is an organizational priority.",
      keywords:
        "women's health at work, women's health in the workplace, menopause at work, gender health gap, female leadership",
    },
    "article-rischio-psicosociale": {
      title: "Psychosocial Risk at Work: Regulation and Data | Eclenia",
      description:
        "Work-related stress: the Legislative Decree 81/2008 framework, the costs according to EU-OSHA and ILO, and why managing psychosocial risk is a strategic lever.",
      keywords:
        "psychosocial risk, work-related stress, workplace stress risk assessment, occupational health compliance, workplace stress prevention",
    },
    resources: {
      title: "Resources | Tools for Organizational Wellbeing",
      description:
        "Briefs, self-assessments and checklists for HR and leaders: practical tools to build measurable, lasting organizational wellbeing.",
    },
    contact: {
      title: "Contact | ECLENIA — Corporate Health, Italy",
      description:
        "Book a Discovery Call with ECLENIA, Corporate Health & Workplace Wellbeing consulting. Based in Nove (Vicenza), Veneto, Italy.",
    },
  },
};

export default seo;
